export interface AccountingSheetInterface {
  status: AccountingSheetStatus;
  number: string;
  startDate: string;
  finishDate: string;
  supplierId: number;
  supplierName: string;
  totalWithoutTax: number;
  taxAmount: number;
  total: number;
  documents: DataForDocumentLink[];
  jbpmProcessId: number;
  jbpmContainerId: string;
  accountDate: string | null;
  documentDate: string | null;
  invoiceNumber: string | null;
  accountNumber: string | null;
  id: number;
  groups: any[];
  comment: string | null;
  fmLegalCode: string;
  contractNumber: string;
  contractDate: string;
  contractPaymentPeriod: string;
  contractPaymentPeriod2: number;
}

interface DataForDocumentLink {
  bucket: string;
  objectName: string;
  type: string;
}

export enum AccountingSheetStatus {
  CREATED = 'created',
  CONTROLLING_APPROVAL_AWAIT = 'controlling_approval',
  ACCOUNTANT_APPROVAL_AWAIT = 'accounting_approval',
  PAYMENT_AWAIT = 'payment_await',
  PAYMENT_DONE = 'payment_done',
  SUPPLIER_CONFIRMATION_AWAIT = 'supplier_confirmation',
  DIADOC_SIGNING_AWAIT = 'diadoc_signing_await',
  PROBLEM = 'problem',
  RECALLED = 'recalled',
}
